import React, { useEffect, useState } from 'react';
import { ApiTwoTone, CopyOutlined } from '@ant-design/icons';
import { Modal, Form, Input, Button, message } from 'antd';
import { useDispatch } from 'react-redux';
import { activeMachine } from '../../../redux/Machine/actions';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const MachinePC = ({ item }) => {
  const dispatch = useDispatch();
  const [Model_visible, setModel_visible] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(item);
  }, [item]);

  const showModal = () => {
    onFill();
    setModel_visible(true);
  };

  const onFill = () => {
    form.setFieldsValue(item);
  };

  const hideModal_Ok = () => {
    form.submit();
  };

  const form_onfinish = (values) => {
    dispatch(activeMachine(item._id, values));
  };

  const hideModal_Cancel = () => {
    setModel_visible(false);
  };

  return (
    <>
      <ApiTwoTone onClick={showModal} twoToneColor={item.islinkedPC ? "green" : "red"} />
      <Modal
        title="Clé d'activation"
        visible={Model_visible}
        onOk={hideModal_Ok}
        onCancel={hideModal_Cancel}
        okText="Valider"
        cancelText="Fermer"
        footer={[
          <Button key="back" onClick={hideModal_Cancel}>Fermer</Button>,
          <Button key="submit" type="primary" onClick={hideModal_Ok}>Générer key</Button>,
        ]}
      >
        <Form
          {...layout}
          name="basic"
          form={form}
          onFinish={form_onfinish}
          initialValues={{ remember: false }}
        >
          <Form.Item
            label="ID"
            name="idpc"
            rules={[{ required: true, message: 'Please input your machine ID!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="CLE"
            name="keypc"
          >
            <Input
              readOnly
              addonAfter={<CopyOutlined
                onClick={() => navigator.clipboard.writeText(item.keypc).then(() => {
                  message.success('Copying to clipboard was successful!');
                }, (err) => {
                  message.error(err);
                })}
                style={{ cursor: 'pointer' }}
              />}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default MachinePC;
